export class LoggedIn {

  loggedIn: boolean;
  activate: boolean;
  secondActivate: boolean;
  otpVerified: boolean;

}
